module.exports = __webpack_public_path__ + "static/media/twitch.6673c10b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/about/twitch.png
// module id = 1489
// module chunks = 0